import { message } from 'ant-design-vue'
import { h } from 'vue'

const createElement = (content: any, _remove: any) => {
  // 定义文本内容及样式（这里的样式延用的官方的）
  const innerText = h(
    'span',
    { style: { color: '#4a5970', fontSize: '14px', fontWeight: 500, whiteSpace: 'pre-line' } },
    content
  )
  // 自定义关闭图标
  const innerIcon = h('i', {
    style: { color: '#455A74 !important', fontSize: '16px', marginLeft: '36px' },
    class: 'iconfont icon-guanbi1 cursor-pointer',
    onClick: () => _remove.func(),
  })
  // 最终返回
  return h('span', {}, [innerText, innerIcon])
}
// 由于 message 有多种状态，这里需要额外处理
const dtMessage: Record<string, any> = {};
// 给 dtMessage 循环赋值不同类型的 message函数
['error', 'success', 'info', 'warning', 'warn', 'loading'].forEach(
  (type: any) => {
    dtMessage[type] = (content: any, duration: number, onClose: () => void) => {
      const _remove: { func?: any } = {}
      // 处理 message[type](config) 参数为对象类型
      if (typeof content === 'object') {
        _remove.func = message[type as any]({
          ...content,
          content: createElement(content?.content, _remove),
        })
      }
      _remove.func = message[type as any](
        createElement(content, _remove) as any,
        duration,
        onClose
      )
      return _remove
    }
  }
)

export default dtMessage
